import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetForingLang} from '../../actions/index';

class Packages extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);

    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetForingLang(token);
    }
    showPackage(id, item){
        this.context.router.push('/subscription/packages/package/');
        localStorage.setItem('id_package', id);
    }
    renderTable(){
        return this.props.lang.foring_lang.results.map((item, i)=>{
            return(
                <div key={item.id} className="white-block common-list clearfix two">
                    <p>{i+1}</p>
                    <p><span className="link-span" onClick={this.showPackage.bind(this, item.id)}>{item.lang.name}</span></p>
                </div>
            )
        })
    }


    render() {
        return (
            <div>
                <div className="dashboard-wrapper">
                    <div className="dashboard-title clearfix">
                        <div className="pull-left">
                            <p className="dashboard-title">Packages for language</p>
                            <p className="dashboard-text">Subscription</p>
                        </div>
                    </div>
                    {this.props.lang.foring_lang.results && this.props.lang.foring_lang.results.length > 0 ?
                        <div className="col-md-12">
                            { this.renderTable() }
                        </div>
                        :
                        <div className={this.props.lang.foring_lang.results && this.props.lang.foring_lang.results.length < 0 || $.isEmptyObject(this.props.lang.foring_lang) ? "for_preloader" : 'for_preloader dn'}>
                            <div className="preloader-wrapper big active">
                                <div className="spinner-layer spinner-blue-only">
                                    <div className="circle-clipper left">
                                        <div className="circle" />
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle" />
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.lang.foring_lang.results && this.props.lang.foring_lang.results.length === 0 && <p className="noResults">No items result</p>}

                    <div className="clearfix"></div>
                </div>
            </div>
        );
    }
}


function  mapStateToProps(state) {
    return{
        lang: state.lang
    }
}
export default connect(mapStateToProps, {GetForingLang})(Packages);



// WEBPACK FOOTER //
// ./src/components/subscription/packages.js